import React, { useEffect, useState } from "react";
import "./Dashboardsuperadmin.css";
import HeaderNavigation from "./../../../../Componants/Common/header Navigation/HeaderNavigation";
import DynamicTabs from "../../../../components/DynamicTabs";
import { getSuperAdminDashboard,getOrganizations } from "../../../../API Service/apiService";
import Paginate from "../../../../Componants/Common/Paginate";
import Loader from "../../../../Componants/Loader/Loader";
import { formatDate } from "../../../../utils/dateFormatter";

const Dashboardsuperadmin = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [organizations, setOrganizations] = useState([]);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [dataSize, setDataSize] = useState(10);
  // const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
 

  

  const handlePageChange=(pageNumber)=>{
    setPage(pageNumber);
  }

  const handleDataSizeChange=(size)=>{
    setDataSize(size);
    setPage(1);
  }
  
  useEffect(()=>{
    fetchDashboardData();
    fetchOrganizations();
  },[page, dataSize]);


  const fetchDashboardData=async()=>{
    setIsLoading(true);
    try{
      const data=await getSuperAdminDashboard();
      setDashboardData(data);
    }catch(error){
      console.error("Error fetching dashboard data:", error);
    }finally{
      setIsLoading(false);
    }
  }

  const fetchOrganizations=async()=>{
    setIsLoading(true);
    try{
      setIsLoading(true);
      let body={
        page:page,
        size:dataSize
      }
      const data=await getOrganizations(body);
      console.log(data.data.organizations );
      setOrganizations(data.data.organizations);
      setTotalRecords(data.data.pagination.totalRecords);
      // setTotalPages(data.data.pagination.totalPages)
    }catch(error){
      console.error("Error fetching organizations:", error);
      setIsLoading(false);
    }finally{
      setIsLoading(false);
    }
  }

  return (
    <> {isLoading && <Loader/>}
      <HeaderNavigation value={"Super Admin"} />
      <DynamicTabs />
      <div className="container-Dashboardsuperadmin">
        <div className="Dashboard-Dashboardsuperadmin">
          <div className="databox-Dashboardsuperadmin">
            <div className="boxone-Dashboardsuperadmin">
              <div className="firsttext--Dashboardsuperadmin">
                Total Subscription
              </div>
              <div className="firsttext--Dashboardsuperadmin">
                {dashboardData?.totalSubscribers}
              </div>
            </div>
            <div className="boxone-Dashboardsuperadmin">
              {" "}
              <div className="firsttext--Dashboardsuperadmin">
                Active Subscription
              </div>
              <div className="firsttext--Dashboardsuperadmin">
                {dashboardData?.activeSubscribers}
              </div>
            </div>
            <div className="boxone-Dashboardsuperadmin">
              {" "}
              <div className="firsttext--Dashboardsuperadmin">
                Stopped Subscription
              </div>
              <div className="firsttext--Dashboardsuperadmin">
                {dashboardData?.stoppedSubscribers}
              </div>
            </div>
            <div className="boxone-Dashboardsuperadmin">
              {" "}
              <div className="firsttext--Dashboardsuperadmin">Total Trials</div>
              <div className="firsttext--Dashboardsuperadmin">
                {dashboardData?.totalTrials}
              </div>
            </div>
          </div>

          <div className="databox-Dashboardsuperadmin">
            <div className="boxone-Dashboardsuperadmin">
              <div className="firsttext--Dashboardsuperadmin">
                Trials Stopped
              </div>
              <div className="firsttext--Dashboardsuperadmin">
                {dashboardData?.stoppedTrials}
              </div>
            </div>
            <div className="boxone-Dashboardsuperadmin">
              {" "}
              <div className="firsttext--Dashboardsuperadmin">
                Trials Coversion
              </div>
              <div className="firsttext--Dashboardsuperadmin">
                {dashboardData?.trialToSubscriptionConversion}
              </div>
            </div>

            <div className="boxone-Dashboardsuperadmin">
              <div className="firsttext--Dashboardsuperadmin">
                MTD Clients Dropped
              </div>
              <div className="firsttext--Dashboardsuperadmin">
                {dashboardData?.droppedSubscriptionsLastMonth}
              </div>
            </div>
            <div className="boxone-Dashboardsuperadmin">
              {" "}
              <div className="firsttext--Dashboardsuperadmin">6 Month Drop</div>
              <div className="firsttext--Dashboardsuperadmin">
                {dashboardData?.droppedSubscriptionsLastSixMonths}
              </div>
            </div>
          </div>

          <div className="chart-Dashboardsuperadmin"></div>
          <div className="table-Dashboardsuperadmin">
            <table>
              <thead>
                <tr>
                  <th>sr No.</th>
                  <th>Company Name</th>
                  <th>Client Name</th>
                  <th>Total Licenses</th>
                  <th>Remaining Licenses</th>
                  <th>Subscription Plan</th>
                  <th>Subscribed On</th>
                  <th>Subs End On</th>
                  <th>Payment Due Date</th>
                </tr>
              </thead>
              <tbody>
                {organizations.map((organization, index)=>{
                  return(
                    <tr key={index}>
                      <td>{(index + 1)+(page-1)*dataSize}</td>
                      <td>{organization.companyName}</td>
                      <td>{organization.clientName}</td>
                      <td>{organization.licenseKeys[0].noOfLicense}</td>
                      <td>{organization.licenseKeys[0].leftLicence}</td>
                      <td>{organization.subscriptionPlanName || "NA"}</td>
                      <td>{formatDate(organization.subscriptionStartDate)}</td>
                      <td>{formatDate(organization.subscriptionEndDate)}</td>
                      <td>{formatDate(organization.paymentDueDate)}</td>
                    </tr>
                  )

                })}
               
              </tbody>
            </table>
          </div>
        </div>
        <div className="pagination-container">
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            dataSize={dataSize}
            onDataSizeChange={handleDataSizeChange}
          />
        </div>
      </div>
    </>
  );
};

export default Dashboardsuperadmin;
